<template>
  <!--费用调整管理（运力商）-->
  <div class="page-box">
    <h4 class="page-box__title">费用调整管理</h4>
    <el-form class=""
             :model="searchData"
             ref="searchForm"
             label-width="100px"
             :inline="true"
             @submit.native.prevent>
      <el-form-item label="运单号">
        <el-input v-model="searchData.nos"
                  size=""
                  clearable
                  class="edit-form__input"
                  placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="主单号">
        <el-input v-model="searchData.mainnos"
                  size=""
                  clearable
                  class="edit-form__input"
                  placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="费用名称">
        <el-select v-model="searchData.feeitemid"
                   size=""
                   class="edit-form__input"
                   placeholder="请选择">
          <el-option
            v-for="(item, index) in feeItemNameList"
            :key="index"
            :label="item.feeitemName"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <!--<el-form-item label="费用状态">
        <el-select v-model="searchData.processstatusdec"
                   size=""
                   class="edit-form__input"
                   placeholder="请选择">
          <el-option
            v-for="(item, index) in [{namec:'待运力商确认',id:101}]"
            :key="index"
            :label="item.namec"
            :value="item.namec"
          ></el-option>
        </el-select>
      </el-form-item>-->
      <el-form-item label=" " label-width="10px">
        <el-button type="primary"
                   icon="el-icon-search"
                   @click="search">查询</el-button>
      </el-form-item>
    </el-form>
    <div class=""
         style="margin: 30px auto 15px;">
      <el-button  type="primary"
                 icon="el-icon-plus"
                 @click="showEditForm()">新增</el-button>
    </div>
    <el-table align="center"
              max-height="600px"
              :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
              size="mini"
              highlight-current-row
              :data="tableData"
              style="width: 100%;"
              border>
      <el-table-column label="序号"
                       type="index"
                       align="center"
                       width="60"></el-table-column>
      <el-table-column label="运单号"
                       align="center"
                       min-width="130"
                       prop="nos"></el-table-column>
      <el-table-column label="主单号"
                       align="center"
                       min-width="130"
                       prop="mainnos"></el-table-column>
      <el-table-column label="费用名称"
                       align="center"
                       min-width="120"
                       prop="feeitemdec"></el-table-column>
      <el-table-column label="费用状态"
                       align="center"
                       width="80"
                       prop="processstatusdec"></el-table-column>
      <el-table-column label="数量"
                       align="center"
                       width="80"
                       prop="piece"></el-table-column>
      <el-table-column label="单价"
                       align="center"
                       width="100"
                       prop="pricenotax"></el-table-column>
      <el-table-column label="费用金额"
                       align="center"
                       width="120"
                       prop="amount"></el-table-column>
      <el-table-column label="计费过程"
                       align="center"
                       min-width="120"
                       prop="calDesc"></el-table-column>
      <el-table-column label="备注"
                       align="center"
                       min-width="100"
                       prop="remarks"></el-table-column>
      <el-table-column label="操作"
                       width="80"
                       fixed="right"
                       align="left">
        <template slot-scope="scope">
          <template v-if="scope.row.processstatusdec !== '已生效'">
            <div class="table-button-plain color-success" @click="showEditForm(scope.row)">修改</div>
          </template>

          <!--<div class="table-button-plain color-danger">删除</div>-->
          <!--<div class="table-button-plain color-primary">提交</div>-->
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="费用维护"
               width="760px"
               @closed="hideEditForm"
               custom-class="edit-dialog"
               :visible.sync="visibleEditForm"
               :close-on-press-escape="false"
               :close-on-click-modal="false">
      <el-form class=""
               :model="editFormData"
               ref="editForm"
               label-width="120px"
               :inline="true"
               @submit.native.prevent>
        <el-form-item label="运/主单号"
                      prop="nos"
                      :rules="formRules.nos">
          <el-input v-model="editFormData.nos"
                    size="mini"
                    class="edit-form__input"
                    placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="费用名称"
                      prop="feeitemid"
                      :rules="formRules.require">
          <el-select v-model="editFormData.feeitemid"
                     size="mini"
                     class="edit-form__input"
                     placeholder="请选择">
            <el-option v-for="(item, index) in feeItemNameList"
                       :key="index"
                       :label="item.feeitemName"
                       :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <br/>
        <el-form-item label="数量"
                      prop="piece"
                      :rules="editFormData.pricenotax||editFormData.piece ? formRules.piece : formRules.no">
          <el-input v-model="editFormData.piece"
                    @change="changeAmountPrice"
                    size="mini"
                    type="number"
                    clearable
                    class="edit-form__input input-number__no-arrows"
                    placeholder="请输入"></el-input>
          <!--<el-select v-model="editFormData.unit"-->
                     <!--size="mini"-->
                     <!--style="width: 70px"-->
                     <!--placeholder="单位">-->
            <!--<el-option v-for="(item, index) in [{namec:'件',id:0}]"-->
                       <!--:key="index"-->
                       <!--:label="item.namec"-->
                       <!--:value="item.id"-->
            <!--&gt;</el-option>-->
          <!--</el-select>-->
        </el-form-item>
        <el-form-item label="单价"
                      prop="pricenotax"
                      :rules="editFormData.pricenotax||editFormData.piece ? formRules.pricenotax : formRules.no">
          <el-input v-model="editFormData.pricenotax"
                    @change="changeAmountPrice"
                    size="mini"
                    type="number"
                    clearable
                    class="edit-form__input input-number__no-arrows"
                    placeholder="请输入"></el-input>
        </el-form-item>
        <br/>
        <el-form-item label="费用总额"
                      prop="amount"
                      :rules="formRules.amount">
          <el-input v-model="editFormData.amount"
                    size="mini"
                    type="number"
                    clearable
                    :disabled="!!editFormData.pricenotax || !!editFormData.piece"
                    class="edit-form__input input-number__no-arrows"
                    placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="币种"
                      prop="currency"
                      :rules="formRules.require">
          <el-select v-model="editFormData.currency"
                     size="mini"
                     class="edit-form__input"
                     placeholder="请选择">
            <el-option v-for="(item, index) in currencyList"
                       :key="index"
                       :label="item"
                       :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <br/>
        <el-form-item label="费用生成时间"
                      prop="arapdate"
                      :rules="formRules.require">
          <el-date-picker placeholder="请选择"
                          class="edit-form__input"
                          size="mini"
                          v-model="editFormData.arapdate"
                          align="right"
                          type="date"
                          value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <br/>
        <el-form-item label="备注"
                      prop="remarks">
          <el-input v-model="editFormData.remarks"
                    size="mini"
                    type="textarea"
                    style="width: 575px;"
                    :rows="4"
                    placeholder="请输入"></el-input>
        </el-form-item>
        <br/>
        <el-form-item label=" " style="text-align: center;width: 600px;margin-top: 30px;">
          <el-button type=""
                     @click="hideEditForm">取消</el-button>
          <el-button type="primary"
                     @click="submitForm()"
                     style="margin-left: 30px;">确认</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import {pagingMixins} from "@/assets/js/pagingMixins";
  import {disposeSearchData} from "@/assets/js/utils";
  import {rulesNotEmpty,validatorGoodsPrice,validatorGoodsQuantity} from "@/assets/js/formRules";

  function baseDataEditData() {
    return {
      "amount": 0, // 费用总金额
      "arapdate": "", // 费用产生时间
      "currency": "", // 币种
      "feeitemid": "", // 费用id
      "id": "", // 主键id
      "nos": "", // 运单号
      "piece": "", // 计费数量
      "pricenotax": "",// 单价
      "remarks": "",// 备注
    }
  }
  export default {
    name: "costAdjustmentManagement",
    mixins:[pagingMixins],
    data() {
      return {
        loading: false,
        /* 筛选 */
        searchData: {
          arapDateEnd:'', // 费用产生结束时间
          arapDateStart:'', // 费用产生开始时间
          feeitemid:'', // 费用名称id
          mainnos:'', // 主单号
          nos:'', // 运单号
          processstatusdec:'', // 费用状态
        },
        /* 选择框 数据 */
        feeItemNameList: [],//费用名称下拉框接口
        currencyList: [],//币种
        /* 编辑弹窗 */
        editFormData: baseDataEditData(),
        formRules:{
          no: [{trigger: 'blur', required: false}],
          require:[rulesNotEmpty()],
          nos:[rulesNotEmpty('运单号')],
          piece:[rulesNotEmpty('数量'), {trigger: 'blur',validator:validatorGoodsQuantity}],
          pricenotax:[rulesNotEmpty('单价'),{trigger:'blur',validator:validatorGoodsPrice}],
          amount:[rulesNotEmpty('费用总额'),{trigger:'blur',validator:validatorGoodsPrice}],
        },
      }
    },
    created(){
      this.getFeeItemNameList();
      this.getList();
    },
    methods:{
      /**
       * 获取 获取费用名称下拉框接口
       */
      getFeeItemNameList() {
        this.loading = true;
        return new Promise((resolve, reject) => {
          this.axios.post('/arapcost/getCostNameList')
            .then(res => {
              this.loading = false;
              if (res.data.code !== 200) {
                this.feeItemNameList = [];
                this.$message.info(res.data.message || "服务器繁忙");
                return false;
              }
              this.feeItemNameList = res.data.datas;
              resolve(res);
            })
            .catch((res) => {
              this.loading = false;
              this.feeItemNameList = [];
            });
        })
      },
      /**
       * 获取 获取费用名称下拉框接口
       */
      getCurrencyList() {
        this.loading = true;
        return new Promise((resolve, reject) => {
          this.axios.get('/filedata/findCurrencyAll')
            .then(res => {
              this.loading = false;
              if (res.data.code !== 200) {
                this.currencyList = [];
                this.$message.info(res.data.message || "服务器繁忙");
                return false;
              }
              this.currencyList = res.data.datas;
              resolve(res);
            })
            .catch((res) => {
              this.loading = false;
              this.currencyList = [];
            });
        })
      },
      /**
       * 获取 列表
       */
      getList(){
        let data = this.jointSearchData();
        this.loading = true;
        return this.axios.post('/arapcost/getMyCostAdjustmentList',data)
          .then(res => {
            this.loading = false;
            if (res.data.code !== 200) {
              this.tableData = [];
              return this.$message.info(res.data.message||"服务器繁忙");
            }
            this.tableData = res.data.datas;
            return Promise.resolve(res);
          })
          .catch((res) => {
            this.loading = false;
            this.tableData = [];
          });
      },
      /**
       * 弹窗
       */
      showEditForm(data) {
        if(!this.currencyList.length) this.getCurrencyList();
        if(data){
          let keys = Object.keys(this.editFormData);
          let merge = {};
          keys.forEach(key=>{
            merge[key] = data[key]||'';
          });
          if(data.calDesc === '手工录入费用'){
            merge.pricenotax = '';
            merge.piece = '';
          }
          if(data.jobtype === 'S'){
            // 运单类型：O:子单 S:主单
            merge.nos = data.mainnos||'';
          }
          this.editFormData = merge;
        }
        this.visibleEditForm = true;
      },
      hideEditForm() {
        this.visibleEditForm = false;
        this.editFormData = baseDataEditData();
      },
      changeAmountPrice(){
        let price = parseFloat(this.editFormData.pricenotax);
        let piece = parseFloat(this.editFormData.piece);
        let amountPrice;
        if(!price || !piece){
          amountPrice = '';
        }else{
          amountPrice = (price * piece).toFixed(2);
        }
        this.editFormData.amount = amountPrice;
      },
      /**
       * 提交表单
       */
      submitForm(formName = 'editForm') {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            // this.$message.success('提交表单');
            this.saveCost();
          } else {
            return false;
          }
        });
      },
      saveCost(){
        this.loading = true;
        let data = Object.assign({},this.editFormData);
        if(!data.id) delete data.id;
        // disposeSearchData(data);
        ['amount','piece','pricenotax'].forEach(key=>{
          data[key] = parseFloat(data[key])||0;
        });
        return new Promise((resolve, reject) => {
          this.axios.post('/arapcost/createCostAdjustment',data)
            .then(res => {
              this.loading = false;
              if (res.data.code !== 200) {
                this.$message.info(res.data.message || "服务器繁忙");
                return false;
              }
              this.$message.success("保存成功");
              this.hideEditForm();
              this.getList();
              resolve(res);
            })
            .catch((res) => {
              this.loading = false;
            });
        })
      },
    },
    computed:{
      countTotalPrice(){
        let price  = parseFloat(this.editFormData.price)||0;
        let num  = parseFloat(this.editFormData.num)||0;
        return  (price * num).toFixed(2) ;
      },
    },
    watch:{
      countTotalPrice(newValue){
        this.editFormData.totalPrice = newValue;
        this.$refs['editForm'].validate();
      },
    }
  }
</script>

<style lang="less">

</style>



// WEBPACK FOOTER //
// src/components/financialManagement/costAdjustmentManagement.vue